<template>
  <!-- 轻量氛围层：避免噪点滤镜 / mix-blend，减少滚动合成开销 -->
  <div
    class="home-page-bg pointer-events-none absolute inset-0 z-0 overflow-hidden"
    aria-hidden="true"
  />
</template>

<style scoped>
.home-page-bg {
  background-color: #f8fafc;
  background-image:
    radial-gradient(ellipse 55% 40% at 6% 0%, rgb(21 94 239 / 12%), transparent 58%),
    radial-gradient(ellipse 45% 35% at 96% 18%, rgb(8 145 178 / 8%), transparent 55%),
    radial-gradient(ellipse 50% 30% at 70% 88%, rgb(21 94 239 / 6%), transparent 60%),
    linear-gradient(165deg, #f8fafc 0%, #f1f5f9 45%, #eef4fb 100%);
}
</style>
